import React, { FunctionComponent } from "react";
import exclamationIcon from "../../../assets/exclamation.svg";

interface ExclamationNoteProps {
  message: string;
}

const ExclamationNote: FunctionComponent<ExclamationNoteProps> = ({
  message,
}) => {
  return (
    <>
      <img
        src={exclamationIcon}
        height="16"
        className="ds-u-margin-right--1"
        alt=""
      />
      <span>{message}</span>
    </>
  );
};

export default ExclamationNote;
